export var SalesOrderType;
(function (SalesOrderType) {
    SalesOrderType[SalesOrderType["STANDARD"] = 1] = "STANDARD";
    SalesOrderType[SalesOrderType["DROP_SHIP"] = 2] = "DROP_SHIP";
    SalesOrderType[SalesOrderType["BACK_ORDER"] = 3] = "BACK_ORDER";
})(SalesOrderType || (SalesOrderType = {}));
//# sourceMappingURL=sales-order-type.js.map